import { Head } from '@components/common/head';
import { NavBarContainer } from '@components/navigation';
import { NoSsr } from '@mui/material';
import { SectionSeparator } from '@styles/layout';
import React, { useState } from 'react';
import { Footer } from '@components/footer';
import { FiltersContainer, SearchPadding, SearchResultsContainer, SearchResultsPadding } from '@styles/search-layout';
import { MobileFilterButton } from '@components/deal-finder/results/MobileFilterButton';
import styled from '@emotion/styled';
import { LazyLoadComponent } from '@components/hoc';
import { DealFinderExpirationCountdownContainer } from '@components/deal-finder/results/token/DealFinderExpirationCountdownContainer';
import { SearchTabsBar } from '@components/search/SearchTabsBar';
import { FiltersMobileDrawerContainer } from '@components/filters/v2/deal-finder/FiltersMobileDrawerContainer';
import { FiltersSideBarContainer } from '@components/filters/v2/deal-finder/FiltersSideBarContainer';
import { PageProps } from '@model/pages';

export interface DealFinderLayoutComponentProps extends PageProps {
  topComponent: JSX.Element | null;
  bottomComponent?: JSX.Element;
  searchComponent: JSX.Element | null;
  noResults: JSX.Element;
  metaDescription: string;
  metaTitle: string;
}

const ExpirationCountdown = styled(DealFinderExpirationCountdownContainer)({
  display: 'none'
});

export const DealFinderLayout = ({
  topComponent,
  bottomComponent,
  searchComponent,
  noResults,
  metaDescription,
  metaTitle,
  promoBannerTripType
}: DealFinderLayoutComponentProps) => {
  const [showFiltersBarDrawer, setShowFiltersBarDrawer] = useState<boolean>(false);

  const toggleFiltersBarDrawer = () => setShowFiltersBarDrawer(!showFiltersBarDrawer);

  return (
    <>
      <Head metaTitle={metaTitle} metaDescription={metaDescription} />
      <NoSsr>
        <ExpirationCountdown />
      </NoSsr>
      <NavBarContainer
        showFiltersBarDrawer={showFiltersBarDrawer}
        promoBannerTripType={promoBannerTripType}
        renderSearch={<SearchTabsBar condensed />}
      />
      <SearchPadding>{topComponent}</SearchPadding>
      <MobileFilterButton onClick={toggleFiltersBarDrawer} />
      <NoSsr>
        <SearchPadding>{noResults}</SearchPadding>
      </NoSsr>
      <SearchResultsPadding>
        <SearchResultsContainer>{searchComponent}</SearchResultsContainer>
        <FiltersContainer>
          <FiltersSideBarContainer />
        </FiltersContainer>
      </SearchResultsPadding>
      <SectionSeparator />
      <FiltersMobileDrawerContainer onClose={toggleFiltersBarDrawer} open={showFiltersBarDrawer} />
      <LazyLoadComponent>
        {bottomComponent}
        <SectionSeparator />
        <Footer />
      </LazyLoadComponent>
    </>
  );
};
